/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserName } from './UserName';

export type SlideAnnotation = {
    readonly id?: number;
    readonly user?: UserName;
    type: SlideAnnotation.type;
    /**
     * Whether author flagged this as a diagnostic freedraw
     */
    is_diagnostic?: boolean;
    /**
     * identifying name for annotation to show in annotation list
     */
    name?: string | null;
    /**
     * label or comment on the object
     */
    label?: string | null;
    /**
     * SVG data in string format for freedraw type
     */
    svg_data?: string | null;
    /**
     * list of x, y points in dictionary style format to draw static line or point based object
     */
    points_list?: any;
    lesion_line?: SlideAnnotation.lesion_line | null;
    subtype?: SlideAnnotation.subtype | null;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace SlideAnnotation {

    export enum type {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
    }

    export enum lesion_line {
        SK = 'SK',
        BCC = 'BCC',
        ASL = 'ASL',
        MEL = 'MEL',
        VV = 'VV',
        LP = 'LP',
        CYST = 'CYST',
        INC = 'INC',
    }

    export enum subtype {
        LG_MEL = 'LG_MEL',
        HG_MEL = 'HG_MEL',
        MEL_JUNC_NEV = 'MEL_JUNC_NEV',
        MEL_COMP_NEV = 'MEL_COMP_NEV',
        MEL_DERMAL_NEV = 'MEL_DERMAL_NEV',
        ASL_MEL = 'ASL_MEL',
        BJCD_NEV_MEL = 'BJCD_NEV_MEL',
        NOS_MEL = 'NOS_MEL',
        SCC = 'SCC',
        SCC_INSITU = 'SCC_INSITU',
        AK = 'AK',
        HAK = 'HAK',
        AIP = 'AIP',
        ASP = 'ASP',
        SCC_ALIS = 'SCC_ALIS',
        NOD = 'NOD',
        INF = 'INF',
        SUP = 'SUP',
        PIC = 'PIC',
        EIC = 'EIC',
    }


}
